import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import { useStyles } from './styles';

const DropDown = ({
  input,
  isHiddenErrorMsg,
  list,
  field,
  className,
  label,
  placeholder,
  inputBaseClass,
  selectRootClass,
  selectIconClass,
  disabled = false,
  meta: { touched, error, submitFailed }
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  return (
    <FormControl
      className={classNames(classes.wrapper, className)}
      disabled={disabled}
    >
      {label && (
        <InputLabel
          className={classes.label}
          htmlFor={`${label}-currency-input`}
          classes={{
            disabled: classes.disabledLabel
          }}
        >
          {t(label)}
        </InputLabel>
      )}
      <Select
        value={input.value}
        onChange={input.onChange}
        classes={{
          root: classNames(classes.selectRoot, selectRootClass),
          icon: selectIconClass,
          disabled: classes.selectRootDisabled
        }}
        displayEmpty
        MenuProps={{
          classes: {
            list: classes.menuList
          }
        }}
        input={
          <InputBase
            classes={{
              root: classNames(classes.inputRoot, inputBaseClass, {
                [classes.error]: (touched || submitFailed) && error
              }),
              disabled: classes.inputRootDisabled
            }}
          />
        }
      >
        {placeholder && (
          <MenuItem value="" disabled className={classes.disabledMenuItem}>
            {t(placeholder)}
          </MenuItem>
        )}
        {list.map((item, index) => (
          <MenuItem
            key={index}
            value={field ? item['id'] : item}
            classes={{ root: classes.menuItemRoot }}
          >
            {field
              ? selectedLanguage === 'Norway' &&
                Object.keys(item['Norwegian']).length
                ? item[`Norwegian`][field]
                : item[field]
              : t(item)}
          </MenuItem>
        ))}
      </Select>
      {!isHiddenErrorMsg && (touched || submitFailed) && error && (
        <FormHelperText error>{t(error)}</FormHelperText>
      )}
    </FormControl>
  );
};

export default DropDown;
